// Gestionnaire d'erreurs pour filtrer les erreurs d'extensions Chrome
export const setupErrorHandling = () => {
  // Intercepter les erreurs de console
  const originalConsoleError = console.error;
  console.error = (...args) => {
    // Filtrer les erreurs d'extensions Chrome
    const errorMessage = args.join(' ');
    if (errorMessage.includes('chrome-extension://') || 
        errorMessage.includes('Requête ignorée (schéma non supporté)') ||
        errorMessage.includes('customScript.bundle.js')) {
      // Ignorer silencieusement ces erreurs
      return;
    }
    // Afficher les autres erreurs normalement
    originalConsoleError.apply(console, args);
  };

  // Intercepter les erreurs non gérées
  window.addEventListener('error', (event) => {
    if (event.filename && event.filename.includes('chrome-extension://')) {
      event.preventDefault();
      return false;
    }
  });

  // Intercepter les promesses rejetées non gérées
  window.addEventListener('unhandledrejection', (event) => {
    const errorMessage = event.reason?.toString() || '';
    if (errorMessage.includes('chrome-extension://') || 
        errorMessage.includes('Requête ignorée (schéma non supporté)')) {
      event.preventDefault();
      return false;
    }
  });
};

// Fonction pour nettoyer les erreurs d'extensions dans les logs
export const filterExtensionErrors = (error) => {
  if (typeof error === 'string') {
    return !error.includes('chrome-extension://') && 
           !error.includes('Requête ignorée (schéma non supporté)') &&
           !error.includes('customScript.bundle.js');
  }
  return true;
};
